// Device-token client helpers for the Authorized Devices section of /billing.
//
// Device tokens are minted by /cv-cad-login (one per cv-cad workstation) and
// stored server-side as sha256(token). This file is the read/revoke side —
// minting lives in CvCadLogin.tsx so the issuance UX can stay focused.
//
// The backing edge function is backend/supabase/functions/device-tokens.

import { supabase, SUPABASE_FN_URL } from '../auth/supabase';

export interface DeviceTokenRow {
  id: string;
  machine_id: string;
  label: string | null;
  last_seen_at: string | null;
  revoked_at: string | null;
  created_at: string;
}

async function authHeader(): Promise<Record<string, string>> {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) throw new Error('not_signed_in');
  return { Authorization: `Bearer ${session.access_token}` };
}

export async function listDeviceTokens(): Promise<DeviceTokenRow[]> {
  const res = await fetch(`${SUPABASE_FN_URL}/device-tokens`, {
    method: 'GET',
    headers: await authHeader(),
  });
  if (!res.ok) throw new Error(`device-tokens list HTTP ${res.status}`);
  const body = await res.json() as { tokens: DeviceTokenRow[] };
  return body.tokens ?? [];
}

export async function revokeDeviceToken(id: string): Promise<void> {
  const res = await fetch(`${SUPABASE_FN_URL}/device-tokens/${encodeURIComponent(id)}`, {
    method: 'DELETE',
    headers: await authHeader(),
  });
  if (!res.ok) throw new Error(`device-tokens revoke HTTP ${res.status}`);
}
